import { Department } from "./department.model";
import { Language } from "./language.model";
import { Person } from "./person.model";
import { Profile } from "./profile.model";
import { UserType } from "./user-type.model";

export class User {

    id?: string;
    identifier?: number;
    active?: boolean;
    isAssigned?: boolean;
    account?: string;
    language?: Language;
    languageId?: string;
    password?: string;
    assignedPassword?: string;
    profiles?: Array<string>;
    person?: Person;
    personId?: string;
    resetPassword?: boolean;
    userType?: UserType;
    userTypeId?: string;
    maskUser?: string;
    maskUserId?: string;
    maskedUser?: User;
    currentUser?: User;
    email?: string;
    phone?: string;
    departmentId?: string;
    department?: Department;
    isDriverId?: number;
    isDriver?: boolean;
    captureVouchersId?: number;
    captureVouchers?: boolean;
    initials?: string;
    nextId?: number;
    name?: string;

    constructor(source: Partial<User>) {
        Object.assign(this, source);
    }
}